"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();

export default {
    // 知识来源
    knowledgeOrigin:function () {
        return Promise.resolve([
            { id:"297",name:"用户创建"},
            { id:"299",name:"事件管理"},
            { id:"301",name:"问题管理"},
            { id:"303",name:"变更管理"},
            { id:"305",name:"发布管理"},
            { id:"307",name:"其他网站"},
        ])
    },
    // 标识为FAQ
    titleFAQ:function () {
        return Promise.resolve([
            { id:"1",name:"是"},
            { id:"2",name:"否"},
        ])
    },
    //获取知识分类列表
    getSortListMes:function (params) {
        return RequestService.get("category/type/list/all",params);
    },
    //根据父分类id,获取知识分类子类列表
    getChildSortListMes:function (params) {
        return RequestService.get("category/children/list/all",params);
    },
    //获取服务目录列表
    getServeListMes:function (params) {
        return RequestService.get("service/list",params);
    },
    //新增知识
    addKnowledge:function (params) {
        return RequestService.post("knowledge/add",params);
    },
    //知识列表
    knowledgeList:function (params) {
        return RequestService.get("knowledge/table",params);
    },
    //修改
    knowledgeUpdate:function (params) {
        return RequestService.post("knowledge/update",params);
    },
    //审批
    knowledgeAudit:function (params) {
        return RequestService.post("knowledge/audit",params);
    },
    //删除
    knowledgeDel:function (params) {
        return RequestService.post("knowledge/delete",params);
    },
    //知识详情
    knowledgeDetail:function (params) {
        return RequestService.get("knowledge/detail",params);
    },
    //知识搜索
    knowledgeQuery:function (params) {
        return RequestService.get("knowledge/query",params);
    },
    //知识历史信息记录
    knowledgeHistory:function (params) {
        return RequestService.get("knowledge/history",params);
    },
    //知识历史版本恢复
    knowledgeBackRenew:function (params) {
        return RequestService.post("knowledge/renew",params);
    },
}